import React from "react";

import Date from './props/Date';
import Description from './props/Description';
import Image from './props/Image';
import Link from './props/Link';
import Title from './props/Title';

const Horizontal = ({
  date,
  description,
  image,
  link,
  properties,
  title
}) => {

  const isEnabled = name => !properties || properties.includes(name);

  const imageStyles = {
    backgroundPosition: 'center',
    backgroundSize: 'cover',
    borderRadius: '2px',
    height: '78px',
    width: '130px',
    display: 'inline-block'
  };

  return (<>
      <table style={{width: '100%', marginBottom: '10px'}}>
        <tbody>
          <tr>
            {isEnabled('image') &&
            <td style={{ width: '30%', verticalAlign: 'top', textAlign: 'center' }}>
              <Image src={image} style={imageStyles} />
            </td>
            }
            <td>
              {isEnabled('title') && <Title value={title}/>}
              {isEnabled('date') && <Date value={date}/>}
              {isEnabled('description') && <Description value={description}/>}
              {isEnabled('link') && <Link value={link}/>}
            </td>
          </tr>
        </tbody>
      </table>
    </>);
};

export default Horizontal;

